import { Button, Modal } from 'antd';
import React, { useEffect, useState, useImperativeHandle } from 'react';
import style from './index.module.scss';
import cn from 'classnames';
import { platform } from 'utils/index';

const TryModal = (props: any, ref: any) => {
  const [modalInfo, setModalInfo] = useState({
    error: false,
    visible: false,
  });
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    setIsMobile(platform().mobile);
  }, []);
  useImperativeHandle(ref, () => ({
    open: (error: boolean, visible: boolean) =>
      setModalInfo({
        error,
        visible,
      }),
  }));
  const onClose = () =>
    setModalInfo({
      ...modalInfo,
      visible: false,
    });
  return (
    <Modal onCancel={onClose} closable={isMobile ? false : true} visible={modalInfo.visible} footer={null} className={cn(style.modal, modalInfo.error && style.errModal)}>
      {modalInfo.error ? (
        <div>
          <div className={style.errTitle}>提交失败</div>
          <p className={style.errText}>出了点问题，请稍后再试。</p>
        </div>
      ) : (
        <>
          <img src={'/v2/images/success.svg'} alt="success" className={style.successIcon} />
          <div className={style.successText}>
            您的信息已经提交成功 <br /> 我们会尽快与您取得联系！
          </div>
        </>
      )}
      <div className={cn(style.btn, modalInfo.error && style.error)}>
        <Button type="primary" onClick={onClose}>
          知道了
        </Button>
      </div>
    </Modal>
  );
};

export default React.forwardRef(TryModal);
